import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function LevelIncome() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("");
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");

  const [TotalAmount, setTotalAmount] = useState(0);
    const [Level, setLevel] = useState("0");
  

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/Adminreport",
        {
          loginid: userId,
          uid: search.slice(2),
          fdate: formdate,
          tdate: todate,
          report: "TradingRevenueIntroBonus",
          status: "2",
          level: Level,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      setTotalAmount(responceRight?.data?.data[0][0].TotalAmount);
      responceRight = responceRight?.data?.data[0];

      console.log("My_Team", responceRight);
      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          Uid: `AC${item.fromid}`,
          Amount: `$ ${item.onamount}`,
          Income: `$ ${item.income}`,
          Level: item.lvl,
          ActivationDate: item.incomedate
        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "User Id", accessor: "Uid" },
      { Header: "Level", accessor: "Level" },
      { Header: "Income", accessor: "Income" },

      { Header: "On Amount", accessor: "Amount" },
      { Header: "Date & Time", accessor: "ActivationDate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Trading Revenue Intro Bonus</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-3">
                      <input
                        type="text"
                        id="txtuid"
                        ng-model="p.uid"
                        onChange={(e) => setSearch(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter User Id"
                      />
                      &nbsp;&nbsp;
                    </div>
                    <div class="col-md-2">
                      <select
                        class="form-control in-ip-1"
                        id="SelectLevel"
                        onChange={(e) => setLevel(e.target.value)}
                        name="SelectLevel">
                          <option value="">Select Level</option>
                        <option value="0">All</option>
                        <option value="1">Level 1</option>
                        <option value="2">Level 2</option>
                        <option value="3">Level 3</option>
                        <option value="4">Level 4</option>
                        <option value="5">Level 5</option>
                        <option value="6">Level 6</option>
                        <option value="7">Level 7</option>
                        <option value="8">Level 8</option>
                        <option value="9">Level 9</option>
                        <option value="10">Level 10</option>
                        <option value="11">Level 11</option>
                        <option value="12">Level 12</option>
                        <option value="13">Level 13</option>
                        <option value="14">Level 14</option>
                        <option value="15">Level 15</option>
                        <option value="16">Level 16</option>
                        <option value="17">Level 17</option>
                        <option value="18">Level 18</option>
                        <option value="19">Level 19</option>
                        <option value="20">Level 20</option>
                        <option value="21">Level 21</option>
                        <option value="22">Level 22</option>
                        <option value="23">Level 23</option>
                        <option value="24">Level 24</option>
                        <option value="25">Level 25</option>
                        <option value="26">Level 26</option>
                        <option value="27">Level 27</option>
                        <option value="28">Level 28</option>
                        <option value="29">Level 29</option>
                        <option value="30">Level 30</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setFromdate(new Date(e.target.value))}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-3">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTodate(e.target.value)}
                        id="todate"
                        name="todate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-3">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                      &nbsp;&nbsp;
                    </div>
                  </div>
                  <div class="row">
                    <h4>
                      <span>Total Income: {TotalAmount}</span>
                    </h4>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LevelIncome;
